export const visit = (vm, at) => {
at({ "zh-cn": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "\u65B0\u6D88\u606F" } } });
};